// -- import * as _ from "lodash-es"
import * as biz_data_helper from "../../shared/biz_data_helper"

const content_type = "CompanyInfo"

const create = function () {
  return {
    content_type: "muji"
  }
}

const descriptor = {}

const biz_data = new biz_data_helper.base_entity_helper(
  content_type,
  create,
  descriptor
)
const fields = {
  default: [
    {
      key: "id",
      label: "编号",
      sortable: true,
      thStyle: { width: "60px" }
    },
    { key: "DataArea", label: "公司", sortable: true },
    { key: "SEI_EntityShortName", label: "公司简称", sortable: true },
    { key: "CustAccountNum", label: "客户编号", sortable: true },
    { key: "CustAccountName", label: "客户名称", sortable: true },
    { key: "VenderAccountNum", label: "供应商编号", sortable: true },
    { key: "VenderAccountName", label: "供应商名称", sortable: true },
    {
      key: "EmailNotifierJson",
      label: "邮件通知",
      sortable: true,
      type: "button",
      button: {
        type: "text",
        icon_class: "iconfont icon-email",
        label: "",
        show_label: true
      },
      thStyle: { width: "80px" }
    },
    {
      key: "modifiedDateTime",
      label: "修改日期和时间",
      type: "datetime",
      sortable: true,
      thStyle: { width: "200px" }
    }
  ]
}

const dataForm = {
  id: "",
  DataArea: "",
  SEI_EntityShortName: ""
}

///前端验证
const rules = {}

const methods = {
  ///get
  async getData(_params) {
    let result = await biz_data
      .selectAction({
        params: _params,
        fields: _.map(fields.default, "key")
      })
      .run()

    if (
      result &&
      result[0].result &&
      result[0].result.data &&
      result[0].result.data.ActionResult &&
      result[0].result.data.ActionResult.Result &&
      result[0].result.data.ActionResult.Result.Data.length > 0
    ) {
      return result[0].result.data.ActionResult.Result.Data
    } else {
      return null
    }
  },
  ///保存法人档案信息
  async saveData(_params) {
    let result = await biz_data
      .updateAction({
        params: _params,
        fields: _.map(fields.default, "key")
      })
      .run()
    if (
      result &&
      result[0].result &&
      result[0].result.data &&
      result[0].result.data.ActionResult &&
      result[0].result.data.ActionResult.Result &&
      result[0].result.data.ActionResult.Result.Data.length > 0
    ) {
      return result[0].result.data.ActionResult.Result.Data
    } else {
      return null
    }
  }
}

export { biz_data, dataForm, fields, methods, rules };

